import p5 from "p5";
import EventEmitter from "./EventEmitter";

export let p5Width;
export let p5Height;


// This function initializes and returns the p5 instance.
export function generateTexture(container1, container2) {
  return new Promise((resolve) => {

    // variables:

    //const container = document.createElement('div');

    // Variables to track when drawing is complete
    let p5InstanceReady = false;
    let p5Instance2Ready = false;

    // Variables to store p5 instances
    let p5Instance, p5Instance2;

    // Function to check if both instances are ready
    const checkIfReady = () => {
      if (p5InstanceReady && p5Instance2Ready) {
        resolve({ p5Instance, p5Instance2 });
      }
    };

          // Variables to store each answer
          let receipient = '';
          let your_name = '';
          let your_message = '';

          let scale = 10
          p5Width = 6378/scale//2000
          p5Height = 10630/scale///2

    //sketch:

    p5Instance = new p5((sketch) => {
      
// You can edit these to create more/less space for your elements
const distanceX = 425/scale; // distance between dots (less distance = more dots)
const distanceY = 425/scale;
const myBorder = 425/scale;

let turq_colour = 'purple'

// don't edit these
const gridX = distanceX/2; //don't edit
const gridY = distanceY/2; //don't edit
//var input = "";

let transA;
let transB;
let transC;
let transD;
let transE;
let transF;
let transG;
let transH;
let transI;
let transJ;
let transK;
let transL;
let transM;
let transN;
let transO;
let transP;
let transQ;
let transR;
let transS;
let transT;
let transU;
let transV;
let transW;
let transX;
let transY;
let transZ;

let transA_lc;
let transB_lc;
let transC_lc;
let transD_lc;
let transE_lc;
let transF_lc;
let transG_lc;
let transH_lc;
let transI_lc;
let transJ_lc;
let transK_lc;
let transL_lc;
let transM_lc;
let transN_lc;
let transO_lc;
let transP_lc;
let transQ_lc;
let transR_lc;
let transS_lc;
let transT_lc;
let transU_lc;
let transV_lc;
let transW_lc;
let transX_lc;
let transY_lc;
let transZ_lc;

let trans_apo
let trans_comma
let trans_fullstop
let trans_semicolon
let trans_else

const today = new Date();
const day = today.getDate();
const month = today.toLocaleString("en-GB", { month: "long" }); // April
const year = today.getFullYear();
const dateString = `${day} ${month} ${year}`;




let myOutput = '';

//let hope_colours = ['#9ebe53','#8dbdff','#f7c116','#f19025','#000000', '#ba66bc']
let hope_colours = ['#9ebe53','#8dbdff','#f7c116','#f19025','#000000', '#ba66bc']
//let hope_colours = ['#9ebe53']
let myColorArray = ['plum', 'lightgreen', 'white', 'slaygray', 'darkgrey', 'coral']
let myEncryption = ["#", "@", "!", "&", "*", "€", "+", "_", "^", "¡", "∞", "•", "£", "¢"];
let badNumbers = [];

// Here we'll load your images (the grid is 760 pixels wide right now), for reference for your image sizes.

sketch.preload = () => {

  // there's 14 different elements

  transA = sketch.loadImage('/SVG/Hope/A.svg')
  transB = sketch.loadImage('/SVG/Hope/B.svg')
  transC = sketch.loadImage('/SVG/Hope/C.svg')
  transD = sketch.loadImage('/SVG/Hope/D.svg')
  transE = sketch.loadImage('/SVG/Hope/E.svg')
  transF = sketch.loadImage('/SVG/Hope/F.svg')
  transG = sketch.loadImage('/SVG/Hope/G.svg')
  transH = sketch.loadImage('/SVG/Hope/H.svg')
  transI = sketch.loadImage('/SVG/Hope/I.svg')
  transJ = sketch.loadImage('/SVG/Hope/J.svg')
  transK = sketch.loadImage('/SVG/Hope/K.svg')
  transL = sketch.loadImage('/SVG/Hope/L.svg')
  transM = sketch.loadImage('/SVG/Hope/M.svg')
  transN = sketch.loadImage('/SVG/Hope/N.svg')
  transO = sketch.loadImage('/SVG/Hope/O.svg')
  transP = sketch.loadImage('/SVG/Hope/P.svg')
  transQ = sketch.loadImage('/SVG/Hope/Q.svg')
  transR = sketch.loadImage('/SVG/Hope/R.svg')
  transS = sketch.loadImage('/SVG/Hope/S.svg')
  transT = sketch.loadImage('/SVG/Hope/T.svg')
  transU = sketch.loadImage('/SVG/Hope/U.svg')
  transV = sketch.loadImage('/SVG/Hope/V.svg')
  transW = sketch.loadImage('/SVG/Hope/W.svg')
  transX = sketch.loadImage('/SVG/Hope/X.svg')
  transY = sketch.loadImage('/SVG/Hope/Y.svg')
  transZ = sketch.loadImage('/SVG/Hope/Z.svg')
  
  transA_lc = sketch.loadImage('/SVG/Hope/a-lc.svg')
  transB_lc = sketch.loadImage('/SVG/Hope/b-lc.svg')
  transC_lc = sketch.loadImage('/SVG/Hope/c-lc.svg')
  transD_lc = sketch.loadImage('/SVG/Hope/d-lc.svg')
  transE_lc = sketch.loadImage('/SVG/Hope/e-lc.svg')
  transF_lc = sketch.loadImage('/SVG/Hope/f-lc.svg')
  transG_lc = sketch.loadImage('/SVG/Hope/g-lc.svg')
  transH_lc = sketch.loadImage('/SVG/Hope/h-lc.svg')
  transI_lc = sketch.loadImage('/SVG/Hope/i-lc.svg')
  transJ_lc = sketch.loadImage('/SVG/Hope/j-lc.svg')
  transK_lc = sketch.loadImage('/SVG/Hope/k-lc.svg')
  transL_lc = sketch.loadImage('/SVG/Hope/l-lc.svg')
  transM_lc = sketch.loadImage('/SVG/Hope/m-lc.svg')
  transN_lc = sketch.loadImage('/SVG/Hope/n-lc.svg')
  transO_lc = sketch.loadImage('/SVG/Hope/o-lc.svg')
  transP_lc = sketch.loadImage('/SVG/Hope/p-lc.svg')
  transQ_lc = sketch.loadImage('/SVG/Hope/q-lc.svg')
  transR_lc = sketch.loadImage('/SVG/Hope/r-lc.svg')
  transS_lc = sketch.loadImage('/SVG/Hope/s-lc.svg')
  transT_lc = sketch.loadImage('/SVG/Hope/t-lc.svg')
  transU_lc = sketch.loadImage('/SVG/Hope/u-lc.svg')
 transV_lc = sketch.loadImage('/SVG/Hope/v-lc.svg')
  transW_lc = sketch.loadImage('/SVG/Hope/w-lc.svg')
  transX_lc = sketch.loadImage('/SVG/Hope/x-lc.svg')
  transY_lc = sketch.loadImage('/SVG/Hope/y-lc.svg')
  transZ_lc = sketch.loadImage('/SVG/Hope/z-lc.svg')
  
  trans_apo = sketch.loadImage('/SVG/Hope/_apostrophe.svg')
  trans_comma = sketch.loadImage('/SVG/Hope/_comma.svg')
  trans_fullstop = sketch.loadImage('/SVG/Hope/_fullstop.svg')
  trans_semicolon = sketch.loadImage('/SVG/Hope/_semicolon.svg')
  trans_else = sketch.loadImage('/SVG/Hope/_else.svg')

}

sketch.setup = () => {

  sketch.createCanvas(p5Width, p5Height); //90x150cm
  //sketch.background(255, 255, 240);
  sketch.background('blue')
  sketch.noLoop()

  /*
var canvasOptions = [6378,7441,8504,9567]
var canvasHeight;

 if (newOutput.length <= 25*17) {
  canvasHeight = canvasOptions[0]
}

else if (newOutput.length <= 25*22) {
  canvasHeight = canvasOptions[1]
}

else if (newOutput.length <= 25*27) {
  canvasHeight = canvasOptions[2]
}

else if (newOutput.length <= 25*32) {
  canvasHeight = canvasOptions[3]
}

else {
  canvasHeight = canvasOptions[3]
} 

   // resizeCanvas(6378, canvasHeight);
    //background(255, 255, 240);

    */
}

  sketch.draw = () => {
  sketch.background(255, 255, 240);
//sketch.frameRate(15)
sketch.noStroke();
  sketch.noFill();

  myOutput = sketch.transToBinaryShort_X2(your_message)
   // .replace(/\s+/g, "");

   sketch.textSize(170/scale);
   sketch.fill('black');
   sketch.textFont('monarch');
   sketch.textAlign(sketch.CENTER,sketch.BOTTOM);
   sketch.textLeading(140/scale);

let myCNumber = '01'
let myName = receipient//'Sami'

sketch.text('*encrypted message* for ' + myName,sketch.width/2,sketch.height-myBorder-300/scale);

sketch.textSize(120/scale)
sketch.text('Nō ' + myCNumber + "/01 • *Hope Blankets* by Palais d'Antoia®\n"+
`${dateString}`,sketch.width/2,sketch.height-myBorder);

   sketch.rectMode(sketch.CENTER)
   sketch.imageMode(sketch.CENTER);
   sketch.blendMode(sketch.MULTIPLY);
   //sketch.background(255, 255, 240);

       // below is the translation process for the visual elements.
    // here you can decide what elements you want for which translation

    let i = 0;

    translationArray:
    for (let y = myBorder + distanceY/2; y <= sketch.height - myBorder - distanceY/2; y += distanceY/2) {
      for (let x = myBorder + distanceX/2; x <= sketch.width - myBorder - distanceX/2; x += distanceX/2) {

        if (i === myOutput.length) {
          break translationArray
        }

        sketch.noStroke();
        sketch.noFill();
        //tint(random(myColorArray));
        //sketch.fill('blue')

        switch (myOutput[i]) {

          

          case '#':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transA, x, y, distanceX, distanceY)
            
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '@':

            
            sketch.tint(sketch.random(hope_colours))
            sketch.image(transB, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)
            
            break;

          case '!':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transC, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '&':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transE_lc, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '*':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transE, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '€':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transF, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '+':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transG, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '_':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transH, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '^':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transI_lc, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '¡':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transJ_lc, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '∞':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transK_lc, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '•':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transL_lc, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '£':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transO, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '¢':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transN_lc, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case ')':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transO_lc, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)

            break;

          case '(':

            sketch.tint(sketch.random(hope_colours))
            sketch.image(transP_lc, x, y, distanceX, distanceY)
            //sketch.ellipse(x,y,distanceX,distanceY)


            break;

        }


        i++

      }
    }

    sketch.blendMode(sketch.BLEND);
    sketch.noTint()

    p5Instance.textureNeedsUpdate = true;

    // Set the flag to true after first draw
    if (!p5InstanceReady) {
      p5InstanceReady = true;
      checkIfReady();
    }
} 



let freeze = false;

EventEmitter.subscribe("freezeP5", (v) => {
  freeze = !!v;
});

EventEmitter.subscribe("updateData", (newData) => {
  receipient = newData.receipient;
  your_name = newData.your_name;
  your_message = newData.your_message;

  if (!freeze) sketch.redraw();
});


      // BINARY

      sketch.transToBinaryShort_X2 = function (input) {

        input = (input ?? "").toString(); // ✅ guard against undefined/null
        let output = []

        for (let i = 0; i < input.length; i++) {

          let bin = input[i].charCodeAt().toString(2);
          output.push(Array(8 - bin.length + 1).join("0") + bin)
        }

        let newOutput = output.join("")

        let newNewOutput = replaceDigits(newOutput)

        function replaceDigits(str) {
          const replacements = {
            '0000': '#',
            '1111': '@',
            '1000': '!',
            '0001': '&',
            '1100': '*',
            '0011': '€',
            '1110': '+',
            '0111': '_',
            '0100': '^',
            '0010': '¡',
            '0110': '∞',
            '1001': '•',
            '1010': '£',
            '0101': '=',
            '1011': ')',
            '1101': '('
          };

          let result = '';
          const length = str.length;

          for (let a = 0; a < length; a += 4) {
            const substring = str.substr(a, 4);
            result += replacements[substring] || substring;
          }

          return result;
        }

        return newNewOutput

      }
/*       function arabicToBinary(text) {
        let binaryCode = '';
      
        for (let i = 0; i < text.length; i++) {
          const unicodeValue = text.charCodeAt(i);
          const binaryValue = unicodeValue.toString(2);
          binaryCode += binaryValue.padStart(8, '0'); // Pad with zeros to ensure 8 bits
        }
      
        let finalBinaryCode = replaceDigits(binaryCode)
        return finalBinaryCode;
      } */

      // SAVE PNG

      sketch.keyTyped = function () {
        if (sketch.key === '=') {
          sketch.saveCanvas('P12.png');

        }

      }

    }, container1);

    p5Instance2 = new p5((sketch) => {

      // Variables:

      let data;
      let myOutput;

      //colours
      let purple_colour = '#670099'
      let blue_colour = '#3e51ff'
      let pink_colour = 'hotpink'
      let turq_colour = 'aqua'
      let orange_colour = '#FF4500'
      let brown_colour = '#640045'
      let yellow_colour = '#f5bf00'
      let white_colour = 'white'
      let black_colour = 'black'

      sketch.setup = () => {

        sketch.createCanvas(p5Width, p5Height); // Create a 512x512 texture
        sketch.background(255, 255, 240);

      };

      sketch.draw = () => {
        sketch.background(255, 255, 240);

        // Set the flag to true after first draw
        if (!p5Instance2Ready) {
          p5Instance2Ready = true;
          checkIfReady();
        }
      };

    }, container2);

  });
}